import request from '../utils/request';

// 查询帮助中心文章列表
export const listArticles = (params) => {
  return request({
    url: '/help-center/article/list',
    method: 'post',
    data: params
  });
};

// 创建帮助中心文章
export const createArticle = (data) => {
  return request({
    url: '/help-center/article/create',
    method: 'post',
    data
  });
};

// 更新帮助中心文章
export const updateArticle = (id, data) => {
  return request({
    url: `/help-center/article/update/${id}`,
    method: 'put',
    data
  });
};

// 更新帮助中心文章状态
export const updateArticleStatus = (id, status) => {
  return request({
    url: `/help-center/article/status/${id}`,
    method: 'put',
    params: { status }
  });
};

